<template>
  <div class="blogInfo" :class="{lan_En : lan != 'zh'}">
    <div class="page_cont">
      <div class="page_title">{{ blogData.title }}</div>
      <div class="page_text text"><p class="page_title1">{{ blogData.category }}</p> {{ new Date(blogData.updateTime).toLocaleString() }}</div>
      <div class="page_img"><img :src="`https://www.deeplink.cloud${blogData.overview}`"/></div>
      <div class="page_text" v-html="blogData.content"></div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, ref, computed, watch, onMounted } from "vue";
  import { useRoute, useRouter } from 'vue-router'
  import { getBlogInfo } from "@/api/index.js"
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  import { useHead } from '@unhead/vue'
  export default defineComponent({
    name: 'BlogInfo',
    setup() {
      const { t, locale } = useI18n();
      const store = useStore()
      let lan = computed(() => {
        return store.state.lan
      })
      const router = useRouter()
      const route = useRoute()
      const blogData = ref('')
      const article = ref({
        title: 'DeepLink - DeepLink-Remote Control and Collaboration Software',
        description: 'Deeplink Remote Control: Connect to any computer at any time. Smooth enough to play games, free for personal use!  Supports PC, Android, RTC(chrome,edge)',
        image: 'https://www.deeplink.cloud/img/media_img13.c8554482.png',
        url: window.location.href // 动态获取当前页面 URL
      })
      const getData = async () => {
        console.log(route, 'route');
        let res_data = {
          lang: lan.value
        }
        // if (route.query.id) {
        //   res_data._id = route.query.id
        // }
        if (route.params.keyword) {
          res_data.route = route.params.keyword
        }
        const data = await getBlogInfo(res_data)
        if (data.success) {
          blogData.value = data.data
          article.value.title = blogData.value.title
          article.value.description = blogData.value.desc
          article.value.image = `https://www.deeplink.cloud${blogData.value.overview}`
          console.log(article.value, 'blogData.value');
        }
        // 动态设置元标签
        useHead({
          title: article.value.title,
          meta: [
            { property: 'og:title', content: article.value.title },
            { property: 'og:description', content: article.value.description },
            { property: 'og:image', content: article.value.image },
            { property: 'og:url', content: article.value.url },
            { property: 'og:type', content: 'article' },
            { name: 'twitter:card', content: 'summary_large_image' },
            { name: 'twitter:title', content: article.value.title },
            { name: 'twitter:description', content: article.value.description },
            { name: 'twitter:image', content: article.value.image }
          ]
        })
      }
      onMounted(async() => {
        await getData()
      })
      return {
        lan,
        blogData,
      };
    }
  })
</script>

<style>
.blogInfo p {
  margin: revert;
}
.blogInfo span {
  margin: revert;
}
.blogInfo div {
  margin: revert;
}
.blogInfo li {
  margin: revert;
}
</style>

<style lang="scss" scoped>
.blogInfo {
  margin: auto;
  width: 100%;
  overflow: hidden;
  font-style: normal;
  position: relative;
  .page_title {
    color: #fff;
    font-size: 48px;
    line-height: 1.1;
    font-weight: 600;
    font-family: Monda;
  }
  .page_title1 {
    font-size: 24px;
    line-height: 1.1;
    font-weight: 600;
    font-family: Outfit;
    color: rgba(255, 255, 255, .8);
  }
  .page_text {
    font-size: 16px;
    line-height: 1.1;
    font-family: Outfit;
    text-align: unset !important;
    color: rgba(255, 255, 255, .5);
    p {
      text-align: unset !important;
    }
  }
  .page_cont {
    position: relative;
    z-index: 2;
    width: 90%;
    // min-width: 600px;
    overflow: hidden;
    max-width: 1100px;
    margin: 100px auto;
    position: relative;
    .text {
      display: flex;
      margin-top: 20px;
      align-items: baseline;
      .page_title1 {
        margin-right: 10px;
      }
    }
    .page_img {
      width: 100%;
      margin: 30px 0;
      overflow: hidden;
      img {
        width: 100%;
        margin: auto;
        border-radius: 50px;
      }
    }
    .page_text {
      width: 100%;
    }
  }
}

</style>

